<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="48" height="48" rx="24" fill="#F9F2FF"/>
  <path d="M14.6667 12V17.3333V12ZM12 14.6667H17.3333H12ZM16 30.6667V36V30.6667ZM13.3333 33.3333H18.6667H13.3333ZM25.3333 12L28.3813 21.1427L36 24L28.3813 26.8573L25.3333 36L22.2853 26.8573L14.6667 24L22.2853 21.1427L25.3333 12Z" stroke="#8F00FF" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
